import { types } from "mobx-state-tree"
import { autorun } from "mobx";

const HistoryStore = types.model({
    history: types.frozen(),
})
.actions(self=>({
    updateHistory: (newHistory)=>{
        self.history = newHistory;
    }
}))

const store = HistoryStore.create({})
export default store;


// WEBPACK FOOTER //
// ./src/stores/HistoryStore.js